"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberPickerContainer = void 0;
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const library_1 = require("library");
const constant_1 = require("./constant");
const NumberPickerContainer = ({ children, deselectable = constant_1.DEFAULT_DESELECTABLE, onChange, range, sort = constant_1.DEFAULT_SORT_DIRECTION, value, }) => {
    // Convert the sort into a comparator.
    const comparator = react_1.default.useMemo(() => {
        return (0, library_1.toComparator)(sort);
    }, [sort]);
    // Convert the range into a list of sorted values.
    const values = react_1.default.useMemo(() => {
        return range.toArray().sort(comparator);
    }, [range, comparator]);
    // Determine the unselected set.
    const unselected = react_1.default.useMemo(() => {
        return R.reject(R.equals(value), values);
    }, [values, value]);
    // Partition the unselected values to the left and to the right.
    const [left, right] = react_1.default.useMemo(() => {
        return R.partition((element) => {
            if (R.isNil(value)) {
                return false;
            }
            return element < value;
        }, unselected);
    }, [unselected, value]);
    // Wrap on change to handle already selected number.
    const wrappedOnChange = react_1.default.useCallback((element) => {
        // When already selected.
        if (element === value) {
            if (deselectable) {
                onChange(undefined);
            }
        }
        else {
            onChange(element);
        }
    }, [onChange, value, deselectable]);
    return children({
        comparator,
        left,
        onChange: wrappedOnChange,
        right,
        unselected,
        values,
    });
};
exports.NumberPickerContainer = NumberPickerContainer;
